import { Translate } from '@heidi-pay/heidi-common-fe/types';
import { useGetFilters } from '@components/TableV2/hooks/useGetFilters';
import { FilterValues, IFilterSettings } from '@components/TableV2/types';
import {
  FilterTypes,
  TableNames,
  missingValuePlaceholder,
} from '@utils/constants';
import { MerchantNoteLabel } from './enums';
import { getDefaultFilterLabels } from './getDefaultFilterLabels';
import { ILabelPermissions } from './types';

interface IUseGetMerchantNotesFilters {
  labelPermissions: ILabelPermissions;
  translate: Translate;
}

interface IMerchantNotesFilterValues extends FilterValues {
  label: string[];
}

export const useGetMerchantNotesFilters = ({
  labelPermissions,
  translate,
}: IUseGetMerchantNotesFilters): IFilterSettings<IMerchantNotesFilterValues> => {
  const initialDefaultValues: IMerchantNotesFilterValues = {
    label: getDefaultFilterLabels(labelPermissions),
  };

  const { filterHandler, filterValues, resetFiltersHandler } = useGetFilters(
    TableNames.MERCHANT_NOTES,
    initialDefaultValues,
  );

  const filterLabelOptions = [
    { id: '', name: missingValuePlaceholder },
    { id: MerchantNoteLabel.SALES, name: translate('OPS_PORTAL.LABEL.SALES') },
    {
      id: MerchantNoteLabel.SUPPORT,
      name: translate('OPS_PORTAL.LABEL.SUPPORT'),
    },
  ];

  return {
    filters: [
      {
        id: 'label',
        label: translate('OPS_PORTAL.LABEL.LABEL'),
        options: filterLabelOptions,
        type: FilterTypes.MULTI_SELECT_DROPDOWN,
        value: filterValues?.label,
      },
    ],
    filterHandler,
    resetFiltersHandler,
    filterValues,
    initialDefaultValues,
  };
};
